export default __webpack_public_path__ + "locales/en/SmartBanner.json?hash=1b57420d611b77a4d693dfb9a4e80c45";